// シフト決定画面のクライアント描画で使う小さなヘルパー（HTML エスケープ・URL 組み立て）

/**
 * HTML に埋め込む文字列をエスケープする
 *
 * @param {unknown} value
 * @returns {string}
 */
export const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
}[char]))

/**
 * クエリ（空の値は除く）を付けた URL を組み立てる
 *
 * @param {string} base
 * @param {Record<string, string|number|null|undefined>} query
 * @returns {string}
 */
export const buildUrl = (base, query = {}) => {
    const params = new URLSearchParams()
    Object.entries(query).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
            params.set(key, String(value))
        }
    })
    const queryString = params.toString()

    return queryString ? `${base}?${queryString}` : base
}

/**
 * リンクの href からクエリをオブジェクトにする
 *
 * @param {string} href
 * @returns {Record<string, string>}
 */
export const queryFromHref = (href) => Object.fromEntries(new URL(href, window.location.origin).searchParams.entries())

/**
 * 条件付きの CSS クラス（空文字は除いて連結する）
 *
 * @param {...(string|false|null|undefined)} classes
 * @returns {string}
 */
export const classNames = (...classes) => classes.filter(Boolean).join(' ')
